import AddNewButton from 'Components/Generic/Buttons/AddNewButton';
import { SITE_PAGES } from 'Config';
import SiteDrawerData from 'Data/SiteDrawerData';
import AdminLanding from './AdminLanding';
import VendorDetails from './Vendors/VendorDetails';
import VendorListView from './Vendors/VendorListView';

const ManageVendorView = () => {
  let breadcrumb = [SITE_PAGES.MANAGE_VENDORS];

  let drawerContent = <VendorDetails editable />;
  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: 'New Vendor',
    });
  };

  let addNewButton = (
    <AddNewButton buttonText='Add Vendor' clickHandler={onClick} tableButton />
  );
  return (
    <AdminLanding breadcrumbs={breadcrumb}>
      <VendorListView addNewVendorButton={addNewButton} />
    </AdminLanding>
  );
};

export default ManageVendorView;
